import React, { useEffect, useState } from "react";
import '../MobileHeader/MobileHeader.css';
import logo from "../MobileHeader/header_logo.png";
import { FaUser } from "react-icons/fa";
import MobileLogout from "../MobileLogOut/MobileLogout";

const MobileHeader = ({ title, onMenuClick }) => {
  const [userName, setUserName] = useState("");
  const [showLogout, setShowLogout] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (user) {
      setUserName(user.AdminUsername || user.mobile || "Admin");
    }
  }, []);

  return (
    <>
      <div className="mobile-header-container">
        <div className="mobile-header-left">
          <div className="mobile-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>

        <div className="mobile-header-title">{title}</div>

        <div
          className="mobile-header-profile"
          onClick={() => setShowLogout(true)}
          style={{ cursor: "pointer" }}
        >
          <FaUser className="mobile-profile-icon" />
          <p>{userName}</p>
        </div>
      </div>

      {showLogout && <MobileLogout onClose={() => setShowLogout(false)} />}
    </>
  );
};

export default MobileHeader;
